<template>
    <div>
        <ul
            class="accordion"
            :class="classes"
        >
            <slot />
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'Accordion',

        props: {
            /**
             * Accordion Icon
             *
             * @values 1 => chevron
             * @values 2 => plus
             * @values 3 => carrot
             */
            icon: {
                type   : String,
                default: '1',
            },

            /**
             * Accordion Separated Style
             */
            separated: {
                type   : Boolean,
                default: false,
            },

            /**
             * Accordion Alt Style
             *
             * <small>Change Accordion background and icon position</small>
             */
            alt: {
                type   : Boolean,
                default: false,
            },
        },

        /**
         * @inheritDoc
         */
        data() {
            return {
                panels: [],
                icons : [
                    'chevron',
                    'plus',
                    'carrot',
                ],
            };
        },

        computed: {
            /**
             * Returns icon specific class
             *
             * @returns {string}
             */
            accordionIcon() {
                const icon = this.icons[this.icon - 1];

                return `accordion-${icon}-icon`;
            },

            /**
             * Returns separated class
             *
             * @returns {string}
             */
            separatedStyle() {
                return (this.separated) ? 'separated' : '';
            },

            /**
             * Icon Position
             *
             * @returns {string}
             */
            iconPosition() {
                return (this.alt) ? 'alt' : '';
            },

            /**
             * Register and join accordion classes
             *
             * @returns {string}
             */
            classes() {
                const classes = [];

                classes.push(this.accordionIcon);
                classes.push(this.separatedStyle);
                classes.push(this.iconPosition);

                return classes.join(' ');
            },
        },

    };
</script>

<style lang="scss" src="./index.scss" />
